import React from 'react';
import ContactForm from '../components/Contact';

const ContactPage = () => {
  return <ContactForm />;
};

export default ContactPage;
